import SeismicWave from './SeismicWave';
export default SeismicWave;



// WEBPACK FOOTER //
// ./resources/assets/js/containers/SeismicWave/index.js